import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface NumberFieldProps {
  field: string;
  defaultValue?: number;
  help?: string;
  required?: boolean;
  onSubmit: (value: unknown) => void;
}

export function NumberField({ field: _field, defaultValue, help, required, onSubmit }: NumberFieldProps): React.ReactElement {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>(defaultValue !== undefined ? String(defaultValue) : '');

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (required && !value.trim()) return;
      onSubmit(value.trim() ? Number(value) : null);
    },
    [value, required, onSubmit],
  );

  return (
    <form className="sp-field sp-field-number" onSubmit={handleSubmit}>
      <input
        className="sp-field-input"
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('fields.enterNumber')}
        autoFocus
      />
      {help && <span className="sp-field-help">{help}</span>}
      <button className="sp-field-submit" type="submit" disabled={required && !value.trim()}>
        {t('fields.submit')}
      </button>
    </form>
  );
}
